<template>
  <div class="students-page">
    <v-container style="max-width: 900px; padding-top: 96px; padding-bottom: 96px">
      <div class="text-center mb-16">
        <p class="eyebrow">{{ $t('nav.forStudents') }}</p>
        <h1 class="page-title">{{ $t('students.headline') }}</h1>
        <p class="page-sub mx-auto mt-4">{{ $t('students.sub') }}</p>
        <v-btn
          color="primary"
          depressed
          rounded
          large
          class="mt-8 px-10"
          style="text-transform: none; font-weight: 700; font-size: 1rem; letter-spacing: 0"
        >
          {{ $t('students.cta') }}
        </v-btn>
      </div>

      <v-row>
        <v-col
          v-for="(item, i) in cards"
          :key="i"
          cols="12"
          sm="6"
          md="4"
        >
          <div class="feature-card">
            <v-icon color="primary" size="32" class="mb-4">{{ item.icon }}</v-icon>
            <h3 class="card-title">{{ item.title }}</h3>
            <p class="card-desc">{{ item.desc }}</p>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'StudentsPage',
  computed: {
    cards() {
      return [
        { icon: 'mdi-flash', title: this.$t('students.card1Title'), desc: this.$t('students.card1Desc') },
        { icon: 'mdi-chart-line', title: this.$t('students.card2Title'), desc: this.$t('students.card2Desc') },
        { icon: 'mdi-account-group', title: this.$t('students.card3Title'), desc: this.$t('students.card3Desc') },
        { icon: 'mdi-robot-outline', title: this.$t('students.card4Title'), desc: this.$t('students.card4Desc') },
        { icon: 'mdi-cellphone', title: this.$t('students.card5Title'), desc: this.$t('students.card5Desc') },
        { icon: 'mdi-trophy-outline', title: this.$t('students.card6Title'), desc: this.$t('students.card6Desc') },
      ]
    },
  },
}
</script>

<style scoped>
.students-page {
  background: #f8f9fc;
  min-height: 100vh;
}

.eyebrow {
  font-size: 0.78rem;
  font-weight: 700;
  color: #4055af;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  margin-bottom: 12px;
}

.page-title {
  font-size: 3rem;
  font-weight: 900;
  color: #1a1a2e;
  letter-spacing: -1.5px;
  line-height: 1.1;
}

@media (max-width: 600px) {
  .page-title { font-size: 2rem; }
}

.page-sub {
  font-size: 1.05rem;
  color: #666;
  line-height: 1.75;
  max-width: 540px;
}

.feature-card {
  background: white;
  border: 1px solid #ebebeb;
  border-radius: 16px;
  padding: 28px 24px;
  height: 100%;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.feature-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 32px rgba(64, 85, 175, 0.1);
}

.card-title {
  font-size: 1rem;
  font-weight: 700;
  color: #1a1a2e;
  margin-bottom: 8px;
}

.card-desc {
  font-size: 0.88rem;
  color: #888;
  line-height: 1.65;
  margin: 0;
}
</style>
